var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_50749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45248 20.0003H12.5479C14.2963 20.0003 15.73 18.6886 15.9542 17.0004H16.5478C18.4511 17.0004 19.9998 15.4517 19.9998 13.5484V3.45296C19.9998 1.54973 18.4511 0.000976562 16.5478 0.000976562H7.45235C5.54911 0.000976562 4.00036 1.54973 4.00036 3.45296V4.00085H3.45248C1.54924 4.00085 0.000488281 5.5496 0.000488281 7.45283V16.5482C0.000488281 18.4516 1.54924 20.0003 3.45248 20.0003ZM6.00029 3.45296C6.00029 2.65229 6.65167 2.00091 7.45235 2.00091H16.5478C17.3485 2.00091 17.9999 2.65229 17.9999 3.45296V13.5483C17.9999 14.3491 17.3485 15.0005 16.5478 15.0005H16V7.45283C16 5.5496 14.4512 4.00085 12.548 4.00085H6.00029V3.45296ZM2.00042 7.45283C2.00042 6.65216 2.6518 6.00078 3.45248 6.00078H12.5479C13.3487 6.00078 14 6.65216 14 7.45283V16.5482C14 17.349 13.3487 18.0004 12.548 18.0004H3.45248C2.6518 18.0004 2.00042 17.349 2.00042 16.5483V7.45283Z",
    fill: "#FB607F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_50749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.cb77523e5078cc4788dba3d5d7aba733.svg";
export { ForwardRef as ReactComponent };